import styled from 'styled-components';

export const Title = styled.h2`
  margin-top: -20px;
  margin-bottom: 12px;
  color: ${props => props.theme.secundaria};
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px 16px;
  row-gap: 8px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  label {
    display: flex;
    align-items: center;
    align-self: center;

    @media (max-width: 768px) {
      align-self: flex-start;
    }

    input {
      appearance: none;
      width: 16px;
      height: 16px;
      border: 2px solid ${props => props.theme.secundaria};
      border-radius: 4px;
      background-color: white;
      cursor: pointer;
      transition:
        background-color 0.3s,
        border-color 0.3s;

      margin-right: 5px;

      :checked {
        background-color: ${props => props.theme.secundaria};
        border-color: ${props => props.theme.secundaria};
      }

      :checked::after {
        content: '✔';
        color: white;
        font-size: 12px;
        text-align: center;
        display: block;
        position: relative;
        top: -2px;
      }
    }
  }
`;
